import $ from 'jquery';

/**
 * Ajax common function
 * @param {string} typeValue POST | GET | PUST
 * @param {string} urlValue url api file
 * @param {object} dataValue form value
 * @returns response success
 */
export function request(typeValue, urlValue, dataValue, token = '') {
  return $.ajax({
    headers: { 'X-CSRF-Token': token },
    type: typeValue,
    url: urlValue,
    data: dataValue,
    dataType: 'json',
  });
}

// Alert thông báo
export function notification(type, value) {
  var className = 'success';
  if (type == 'ERROR') {
    className = 'error';
  }

  var html = '<div class="alert-thongbao ' + className + '">';
  html += value;
  html += '</div>';
  $('body').append(html);
  setTimeout(function () {
    $('.alert-thongbao').remove();
  }, 1000);
}

export function notificationInline(type, value, classView) {
  var className = 'success';
  if (type == 'ERROR') {
    className = 'error';
  }
  var html = '<div class="alert-thongbao-inline ' + className + '">';
  html += value;
  html += '</div>';
  $('.' + classView).append(html);
  setTimeout(function () {
    $('.alert-thongbao-inline').remove();
  }, 5000);
}

/**
 * Hiển thị thông báo trong component
 * @param {*} classParent Tên class cha
 * @param {*} type Kiểu thông báo
 * @param {*} value Text thông báo
 * @param {*} time Thời gian hiển thị
 */
export function notificationComponent(classParent, type, value, time) {
  var className = 'success';
  if (type == 'ERROR') {
    className = 'error';
  }

  var timeSet = 5000;
  if (time) {
    timeSet = time;
  }

  var html = '<div class="thongbao ' + className + '">';
  html += value;
  html += '</div>';
  $('.' + classParent).append(html);
  setTimeout(function () {
    $('.thongbao').remove();
  }, timeSet);
}

export function validateEmail(email) {
  var re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function customNumberFormat(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function validatePhone(phone) {
  var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
  return re.test(String(phone).toLowerCase());
}

export function getYoutubeVideoId(url) {
  try {
    var queryString = new URL(url).search;
    var params = new URLSearchParams(queryString);
    var videoId = params.get('v');

    if (videoId && videoId.length > 0) {
      return videoId;
    } else {
      return '';
    }
  } catch (error) {
    return false;
  }
}
